import {
  PHASES,
  MODERATE_DELAY_MS,
  MODERATE_EXPIRY_MS,
} from '@edulastic/constants/educationJoyrides'

/**
 * @returns {'aggressive'|'moderate'|'moderate_skipped'|null}
 */
export const resolveJoyrideVariant = (trackState, now = Date.now()) => {
  if (process.env.REACT_APP_QA_ENV) {
    return null
  }

  if (!trackState?.phase || trackState.phase === PHASES.NONE) {
    return 'aggressive'
  }

  const { phase, aggressiveDismissedAt, moderateDismissedAt } = trackState

  if (phase === PHASES.COMPLETED || phase === PHASES.MODERATE_SKIPPED) {
    return null
  }

  if (phase === PHASES.AGGRESSIVE_DISMISSED) {
    if (!aggressiveDismissedAt) {
      return 'aggressive'
    }

    if (moderateDismissedAt) {
      return null
    }

    const elapsed = now - aggressiveDismissedAt

    if (elapsed < MODERATE_DELAY_MS) {
      return null
    }

    if (elapsed >= MODERATE_EXPIRY_MS) {
      return 'moderate_skipped'
    }

    return 'moderate'
  }

  return null
}

export const buildTrackStateAfterDismiss = ({
  trackState,
  variant,
  now = Date.now(),
}) => {
  if (variant === 'aggressive') {
    return {
      phase: PHASES.AGGRESSIVE_DISMISSED,
      aggressiveDismissedAt: now,
      moderateDismissedAt: null,
    }
  }

  if (variant === 'moderate') {
    return {
      phase: PHASES.COMPLETED,
      aggressiveDismissedAt: trackState?.aggressiveDismissedAt ?? now,
      moderateDismissedAt: now,
    }
  }

  if (variant === 'moderate_skipped') {
    return {
      phase: PHASES.MODERATE_SKIPPED,
      aggressiveDismissedAt: trackState?.aggressiveDismissedAt ?? now,
      moderateDismissedAt: null,
    }
  }

  return trackState
}
